import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { MobileLinkContent } from "../Component/MobileLinkContent";

const MobileLink = () => {
  const seoData = getSEOData("/mobile-link");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <MobileLinkContent />
    </>
  );
};

export default MobileLink;
